import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OwnPartnershipRoutingModule } from './own-partnership-routes';
import { OwnPartnershipAddComponent } from './own-partnership-add/own-partnership-add.component';
import { ComponentsModule } from '../../components/components.module';
import { OwnPartnershipListPageComponent } from './own-partnership-list/own-partnership-list.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    OwnPartnershipRoutingModule
  ],
  declarations: [
    OwnPartnershipAddComponent,
    OwnPartnershipListPageComponent,
  ]
})
export class OwnPartnershipModule { }
